export enum PriceCategory {
  Cheap = 'CHEAP',
  Average = 'AVERAGE',
  Expensive = 'EXPENSIVE',
}
